<template>
  <ul class="cj-game-list">
    <li
      class="game-list-item"
      :class="itemClasses(g)"
      :data-game="g.id"
      v-for="g in games"
      :key="g.id"
      @click="$emit('selected', g.id)"
    >
      <div class="container">
        <div class="logo" />
      </div>

      <p v-html="g.description" />

      <CJGameListItemLocked v-if="!isGameUnlocked(g.id)" />
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'

import CJGameListItemLocked from '@/components/CJGameListItemLocked'

export default {
  name: 'CJGameList',

  components: { CJGameListItemLocked },

  props: {
    games: {
      type: Array,
      default: () => [ ],
    },

    enableLocked: Boolean,
  },

  computed: {
    ...mapGetters([ 'isGameUnlocked' ]),
  },

  methods: {
    itemClasses (game) {
      const unlockMode = !this.isGameUnlocked(game.id) && this.enableLocked
      return [
        game.id,
        unlockMode && 'unlock-game',
        !this.isGameUnlocked(game.id) && !this.enableLocked && 'disabled',
      ]
    },
  },
}
</script>

<style lang="stylus" scoped>
  ul.cj-game-list
    margin: 0 0 20px
    padding: 0
    list-style-type: none

    li > *
      pointer-events: none

    @media screen and (min-device-width: 1024px)
      display: flex
      flex-wrap: wrap
      justify-content: space-between
      margin: 0 0 -10px
      width: 710px

    > .game-list-item
      position: relative
      cursor: pointer

      &.disabled
        cursor: auto

      .container
        max-width: 300px
        padding: 4px
        animation: highlight-anim 1s linear infinite
        background-image: linear-gradient(to right, \
                                          #d6d6d6 0%, \
                                          #9d9fa1 25%, \
                                          #d6d6d6 50%, \
                                          #9d9fa1 75%, \
                                          #d6d6d6 100%)

        .logo
          background-color: #1c3598

      p
        margin: 0.5rem auto 2.5rem
        text-align: center
        line-height: 1.2
        width: 260px

      .cj-game-list-item-locked
        position: absolute
        top: 138px
        right: -10px
</style>
